export const FETCH_SITE_NAMES_REQUEST = "FETCH_SITE_NAMES_REQUEST";
export const FETCH_SITE_NAMES_SUCCESS = "FETCH_SITE_NAMES_SUCCESS";
export const FETCH_SITE_NAMES_FAILURE = "FETCH_SITE_NAMES_FAILURE";
